import { Button } from 'components/Button'
import Styles from './ExternalIntegrations.module.scss'
import CircleCheck from 'almanac-ui/icons/16/CircleCheck'
import { useOpenSettings } from 'hooks/useOpenSettings'
import { SettingScreen } from 'components/Settings/types'
import { Heading } from 'almanac-ui/Heading/Heading'
import { ChevronRight } from 'blaze-ui/icons/24'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

interface ExportOptionProps {
  icon: React.ReactNode
  title: string
  description: string
  isConnected: boolean
  buttons?: React.ReactNode
}

export const ExportOption = ({ icon, title, description, buttons, isConnected }: ExportOptionProps) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const { openSettings } = useOpenSettings()

  return (
    <div className={Styles.card}>
      {isConnected && (
        <Button
          className={Styles.connected}
          frontIcon={CircleCheck}
          variant={isSystemRedesignEnabled ? 'secondary' : 'tertiary'}
          onPress={() => openSettings(SettingScreen.Integrations)}
        >
          Connected
        </Button>
      )}
      {icon}
      <div className={Styles.details}>
        <Heading level={4}>{title}</Heading>
        <div className={Styles.cardDescription}>{description}</div>
      </div>
      <div className={Styles.buttonsContainer}>{buttons}</div>
      <div className={Styles.mobileRightChevron}>
        <ChevronRight size={16} color={'var(--dark-40)'} />
      </div>
    </div>
  )
}
